import { render, staticRenderFns } from "./MemberAddressEdit.vue?vue&type=template&id=b82f7784"
import script from "./MemberAddressEdit.vue?vue&type=script&lang=js"
export * from "./MemberAddressEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports